import { Brain, Heart, Sparkles } from 'lucide-react';
import { content } from '../content';

const BespokeSection = () => {
  const pillars = [
    {
      icon: Brain,
      title: content.bespoke.pillars.mind.title,
      description: content.bespoke.pillars.mind.description,
    },
    {
      icon: Heart,
      title: content.bespoke.pillars.body.title,
      description: content.bespoke.pillars.body.description,
    },
    {
      icon: Sparkles,
      title: content.bespoke.pillars.wisdom.title,
      description: content.bespoke.pillars.wisdom.description,
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-[#FCF9F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl lg:text-6xl serif font-light text-gray-900 mb-6">
            {content.bespoke.heading}
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-4">
            {content.bespoke.paragraph1}
          </p>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed font-medium">
            {content.bespoke.paragraph2}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 mt-16">
          {pillars.map((pillar) => {
            const IconComponent = pillar.icon;
            return (
              <div key={pillar.title} className="text-center space-y-4">
                <div className="inline-flex items-center justify-center w-20 h-20 bg-purple-100 rounded-full mb-2 transition-transform duration-300 hover:scale-110">
                  <IconComponent className="text-purple-600" size={32} strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-medium text-gray-800">
                  {pillar.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BespokeSection;